<!-- @if (currentScreen == 'Tablet' || currentScreen == 'Desktop') {
<div nz-row>
  @if (currentRoute !='/login' && currentRoute!='/' && !currentRoute.includes('/otp-verification') &&
  !currentRoute.includes('/sign-up') &&
  currentRoute!='/signup-success' && currentRoute && !currentRoute.startsWith('/feedback/builder') &&
  !currentRoute.startsWith('/feedback/responses')){
  <div nz-col nzSpan="24">
    <app-header></app-header>
  </div>
  <div nz-col nzSpan="1">
    <app-sidemenu [activeRoute]="currentRoute"></app-sidemenu>
  </div>
  }
  <div nz-col #scrollContainer [nzSpan]="currentRoute!='/login' && currentRoute!='/'  && !currentRoute.includes('/otp-verification') && !currentRoute.includes('/sign-up')  && currentRoute!='/signup-success'&& !currentRoute.startsWith('/feedback/builder') &&
  !currentRoute.startsWith('/feedback/responses') ? 23 :  24" class="outLet" [ngClass]="{'no_outLet':currentRoute!='/login' && currentRoute!='/'  && !currentRoute.includes('/otp-verification') && !currentRoute.includes('/sign-up')  && currentRoute!='/signup-success' && !currentRoute.startsWith('/feedback/builder') &&
  !currentRoute.startsWith('/feedback/responses')}">
    <router-outlet></router-outlet>
  </div>
</div>
} -->


<!-- One router-outlet per shell. Sync screen size so mobile never flashes desktop
     chrome (that remounts the outlet and can drop post-login /dashboard). -->
@if (isMobileScreen) {
<div nz-row>

  @if (showMobileChrome) {
  <div nz-col nzSpan="24">
    <app-mobile-header [currentRoute]="currentRoute"></app-mobile-header>
  </div>
  }

  <div nz-col #scrollContainer nzSpan="24" class="outLet_mobile"
    [ngClass]="{ 'no_outLet_mobile': showLayout, 'outLet_mobile--settings': currentRoute.startsWith('/mobile-settings') }">
    <router-outlet></router-outlet>
  </div>

  @if (showMobileBottomNav) {
  <div nz-col nzSpan="24">
    <app-mobile-bottom [activeRoute]="currentRoute"></app-mobile-bottom>
  </div>
  }
</div>
} @else {
<or-app-shell>
<div nz-row class="main-layout">

  @if (showLayout) {
  <div nz-col [nzSpan]="isExpanded ? 4 : 1" class="sidebar-transition sidebar-col">
    <app-sidemenu [activeRoute]="currentRoute" [expanded]="isExpanded" (toggleMenu)="toggleMenu()"></app-sidemenu>
  </div>

  <div nz-col [nzSpan]="isExpanded ? 20 : 23" class="main-content-col sidebar-transition">
    <app-header></app-header>
    <div #scrollContainer class="outLet">
      <router-outlet></router-outlet>
    </div>
  </div>
  } @else {
  <div nz-col nzSpan="24" #scrollContainer class="outLet no_outLet">
    <router-outlet></router-outlet>
  </div>
  }

</div>
</or-app-shell>
}

<!-- Shared custom date range modal (overview pages via CustomDateModalService) -->
<nz-modal
  [(nzVisible)]="customDate.visible"
  nzCloseIcon="close"
  (nzOnCancel)="customDate.cancel()"
  [nzFooter]="null"
  [nzBodyStyle]="customDateBodyStyle"
  nzCentered
  [nzWidth]="customDateModalWidth"
  [nzClassName]="customDateModalClass">
  <ng-container *nzModalContent>
    <ng-container
      *ngTemplateOutlet="isCustomDateMobile ? customDateMobileTpl : customDateDesktopTpl">
    </ng-container>
  </ng-container>
</nz-modal>

<ng-template #customDateDesktopTpl>
  <div class="custom-date-desktop">
    <header class="custom-date-desktop__title-row">
      <span class="custom-date-desktop__icon-wrap">
        <lucide-icon name="calendar" size="22"></lucide-icon>
      </span>
      <div class="custom-date-desktop__title-copy">
        <h3 class="custom-date-desktop__title">Custom Date Range</h3>
        <p class="custom-date-desktop__subtitle">Pick a start and end date for your overview data</p>
      </div>
    </header>

    <div class="custom-date-grid">
      <section class="custom-date-column">
        <div class="custom-date-column__head">
          <span class="custom-date-column__badge custom-date-column__badge--start">Start</span>
          <label class="custom-date-column__label">
            From Date <span class="custom-date-required">*</span>
          </label>
        </div>
        <div class="custom-date-column__picker">
          <or-date-picker
            class="custom-date-picker custom-date-picker--desktop"
            presentation="inline"
            valueKind="date"
            type="date"
            ariaLabel="From date"
            [(ngModel)]="customDate.formDate"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        @if (customDate.dateError && !customDate.formDate) {
        <p class="custom-date-error-text">Please select a start date</p>
        }
        <div class="custom-date-summary" [class.custom-date-summary--filled]="!!customDate.formDate">
          <span class="custom-date-summary__label">Selected start</span>
          <span class="custom-date-summary__value">
            {{ customDate.formDate ? customDate.moment(customDate.formDate).format('DD MMM YYYY') : 'Not selected yet' }}
          </span>
        </div>
      </section>

      <section class="custom-date-column">
        <div class="custom-date-column__head">
          <span class="custom-date-column__badge custom-date-column__badge--end">End</span>
          <label class="custom-date-column__label">
            To Date <span class="custom-date-required">*</span>
          </label>
        </div>
        <div class="custom-date-column__picker">
          <or-date-picker
            class="custom-date-picker custom-date-picker--desktop"
            presentation="inline"
            valueKind="date"
            type="date"
            ariaLabel="To date"
            [(ngModel)]="customDate.toDate"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        @if (customDate.dateError && !customDate.toDate) {
        <p class="custom-date-error-text">Please select an end date</p>
        }
        <div class="custom-date-summary" [class.custom-date-summary--filled]="!!customDate.toDate">
          <span class="custom-date-summary__label">Selected end</span>
          <span class="custom-date-summary__value">
            {{ customDate.toDate ? customDate.moment(customDate.toDate).format('DD MMM YYYY') : 'Not selected yet' }}
          </span>
        </div>
      </section>
    </div>

    <footer class="custom-date-actions">
      <button
        class="custom-date-btn-apply"
        nz-button
        nzType="primary"
        type="button"
        [nzLoading]="customDate.dateLoading"
        (click)="customDate.submit()">
        <span class="custom-date-btn-apply__inner">
          <lucide-icon name="check" size="16"></lucide-icon>
          <span>Apply Dates</span>
        </span>
      </button>
    </footer>
  </div>
</ng-template>

<ng-template #customDateMobileTpl>
  <div class="custom-date-mobile">
    <header class="custom-date-mobile-header">
      <div class="custom-date-mobile-header__icon-wrap">
        <lucide-icon name="calendar" size="22"></lucide-icon>
      </div>
      <h3 class="custom-date-mobile-header__title">Custom Date Range</h3>
      <p class="custom-date-mobile-header__subtitle">Select start and end dates</p>
    </header>

    <div class="custom-date-mobile-range">
      <div class="custom-date-mobile-range__chip" [class.custom-date-mobile-range__chip--filled]="customDate.hasDate(customDate.formDate)">
        <span class="custom-date-mobile-range__chip-label">Start</span>
        <span class="custom-date-mobile-range__chip-value">{{ customDate.formatDisplayDate(customDate.formDate) }}</span>
      </div>
      <lucide-icon name="arrow-right" size="16" class="custom-date-mobile-range__arrow"></lucide-icon>
      <div class="custom-date-mobile-range__chip" [class.custom-date-mobile-range__chip--filled]="customDate.hasDate(customDate.toDate)">
        <span class="custom-date-mobile-range__chip-label">End</span>
        <span class="custom-date-mobile-range__chip-value">{{ customDate.formatDisplayDate(customDate.toDate) }}</span>
      </div>
    </div>

    <div class="custom-date-mobile-tabs" role="tablist">
      <button
        type="button"
        class="custom-date-mobile-tabs__btn"
        [class.custom-date-mobile-tabs__btn--active]="customDate.mobileActiveTab === 'start'"
        (click)="customDate.setMobileTab('start')">
        From Date
      </button>
      <button
        type="button"
        class="custom-date-mobile-tabs__btn"
        [class.custom-date-mobile-tabs__btn--active]="customDate.mobileActiveTab === 'end'"
        (click)="customDate.setMobileTab('end')">
        To Date
      </button>
    </div>

    <div class="custom-date-mobile-body">
      @if (customDate.mobileActiveTab === 'start') {
      <section class="custom-date-section custom-date-section--active">
        <or-date-picker
          class="custom-date-picker custom-date-picker--mobile"
          presentation="inline"
          valueKind="date"
          type="date"
          ariaLabel="From date"
          [(ngModel)]="customDate.formDate"
          (ngModelChange)="customDate.onStartDateChange($event)"
          [ngModelOptions]="{ standalone: true }"
        />
        @if (customDate.dateError && !customDate.formDate) {
        <p class="custom-date-error-message">
          <lucide-icon name="alert-triangle" size="14"></lucide-icon>
          <span>Please select a start date</span>
        </p>
        }
      </section>
      } @else {
      <section class="custom-date-section custom-date-section--active">
        <or-date-picker
          class="custom-date-picker custom-date-picker--mobile"
          presentation="inline"
          valueKind="date"
          type="date"
          ariaLabel="To date"
          [(ngModel)]="customDate.toDate"
          (ngModelChange)="customDate.onEndDateChange($event)"
          [ngModelOptions]="{ standalone: true }"
        />
        @if (customDate.dateError && !customDate.toDate) {
        <p class="custom-date-error-message">
          <lucide-icon name="alert-triangle" size="14"></lucide-icon>
          <span>Please select an end date</span>
        </p>
        }
      </section>
      }

      <p class="custom-date-helper">
        <lucide-icon name="lightbulb" size="14"></lucide-icon>
        <span>Pick a start date, then switch to To Date and choose the end.</span>
      </p>
    </div>

    <footer class="custom-date-mobile-footer">
      <button class="custom-date-btn-cancel" nz-button type="button" (click)="customDate.cancel()">
        Cancel
      </button>
      <button
        class="custom-date-btn-apply"
        nz-button
        nzType="primary"
        type="button"
        [nzLoading]="customDate.dateLoading"
        (click)="customDate.submit()">
        <span class="custom-date-btn-apply__inner">
          @if (customDate.dateLoading) {
          <lucide-icon name="loader-2" [class.spin]="true" size="14"></lucide-icon>
          <span>Loading...</span>
          } @else {
          <lucide-icon name="check" size="14"></lucide-icon>
          <span>Apply Dates</span>
          }
        </span>
      </button>
    </footer>
  </div>
</ng-template>

<!-- <div nz-col [nzSpan]="currentRoute!='/login' && currentRoute!='/'  && !currentRoute.includes('/otp-verification') && !currentRoute.includes('/sign-up')  && currentRoute!='/signup-success'&& !currentRoute.startsWith('/feedback/builder') &&
  !currentRoute.startsWith('/feedback/responses') ? 23 :  24" class="outLet" [ngClass]="{'no_outLet':currentRoute!='/login' && currentRoute!='/'  && !currentRoute.includes('/otp-verification') && !currentRoute.includes('/sign-up')  && currentRoute!='/signup-success' && !currentRoute.startsWith('/feedback/builder') &&
  !currentRoute.startsWith('/feedback/responses')}">
    <router-outlet></router-outlet>
  </div> -->